import React, { useState } from 'react';
import SvgContent from '../../components/Svgcontent';
import "../../assets/css/comparison.css"
import SelectCollege from './selectcollege';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";

function Comparison({ onCloseHandler }) {
    const [openSelectCollege, setOpenSelectCollege] = useState(null);
    const [collImageFirst, setCollImageFirst] = useState(null);
    const [collImageSec, setCollImageSec] = useState(null);
    const navigate = useNavigate();

    const compareColleges = () => {

        if (collImageFirst && collImageSec) {
            navigate("/college_comparison", {
                state: {
                    img_1: collImageFirst || "", img_2: collImageSec || ""
                }
            });
        } else {
            toast.error("Required all fields");
        }

    };

    const onCloseHandlerSel = () => {
        setOpenSelectCollege(null);
        setCollImageFirst(null);
        setCollImageSec(null);
    };

    const sendData = (sData) => {
        if (openSelectCollege === "left") {
            setCollImageFirst(sData);
        }
        else if (openSelectCollege === "right") {
            setCollImageSec(sData);
        }

        setTimeout(() => {
            setOpenSelectCollege(null);
        }, 500);
    };

    return (
        <div className="popup-overlay">
            <ToastContainer />
            <div
                className="popup-content form-popup"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="aapnow_overlay">
                    <div className="aapnow_modal" style={{ width: "48%" }}>
                        <div className="aapnow_header">
                            <h2>Compare Colleges</h2>
                            <span className="aapnow_close" onClick={() => onCloseHandler("comparison")}>
                                <SvgContent svg_name="close" className="closestyle" />
                            </span>
                        </div>

                        <div className="aapnow_body w-100">
                            <div className="comp_container d-center mb-4 mt-4 flex-wrap">
                                {collImageFirst ? (
                                    <div className='position-relative'>
                                        <img src={collImageFirst?.college_primary_image} className='compcolimage-st' alt='college_primary_image' />
                                        <span className="aapnow_close compcolselcol-st" onClick={() => setCollImageFirst(null)}>
                                            <SvgContent svg_name="close" stroke="#fff" className="closestyle" />
                                        </span>
                                    </div>
                                ) : (
                                    <>
                                        <div className="addcomparison-btn" onClick={() => setOpenSelectCollege("left")}>
                                            <SvgContent
                                                svg_name="add_box"
                                                width="220"
                                                height="220"
                                                stroke="#0b79873d"
                                            />
                                        </div>

                                        <div className="mbaddcomparison-btn" onClick={() => setOpenSelectCollege("left")}>
                                            <SvgContent
                                                svg_name="add_box"
                                                width="92"
                                                height="92"
                                                stroke="#0b79873d"
                                            />
                                        </div>
                                    </>

                                )}

                                <div className='compcolldiv-st'>
                                    <SvgContent svg_name="diff" width="60" height="60" stroke="#d8e7e9" className="poscol-st" />
                                </div>
                                <div className='mbcompcolldiv-st'>
                                    <SvgContent svg_name="diff" width="30" height="30" stroke="#d8e7e9" className="poscol-st" />
                                </div>
                                {collImageSec ? (
                                    <div className='position-relative'>
                                        <img src={collImageSec?.college_primary_image} className='compcolimage-st' alt='college_primary_image' />
                                        <span className="aapnow_close compcolselcol-st" onClick={() => setCollImageSec(null)}>
                                            <SvgContent svg_name="close" stroke="#fff" className="closestyle" />
                                        </span>
                                    </div>
                                ) : (
                                    <>
                                        <div className="addcomparison-btn" onClick={() => setOpenSelectCollege("right")}>
                                            <SvgContent
                                                svg_name="add_box"
                                                width="220"
                                                height="220"
                                                stroke="#0b79873d"
                                            />
                                        </div>

                                        <div className="mbaddcomparison-btn" onClick={() => setOpenSelectCollege("right")}>
                                            <SvgContent
                                                svg_name="add_box"
                                                width="92"
                                                height="92"
                                                stroke="#0b79873d"
                                            />
                                        </div>
                                    </>

                                )}
                            </div>
                            <button className="aapnow_submit" onClick={compareColleges}>
                                <div className="aapnow_svg-wrapper">
                                    <SvgContent width="40"
                                        height="40" svg_name="compare_zz" stroke="white" />
                                </div>
                                <span>Compare</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {openSelectCollege && (<SelectCollege data={{ collImageFirst, collImageSec }} onCloseHandlerSel={onCloseHandlerSel} sendData={sendData} />)}
        </div >
    )
}

export default Comparison
